import React from 'react'
import './AboutHero.scss'

export class AboutHero extends React.Component {
  render() {
    return (
      <div
        className="contact-hero"
        style={{ backgroundImage: 'url(/contactbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>About Rackner</h1>
            <h2>Delivering Decision Advantage Since 2015</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default AboutHero
